import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "../../lib/api";
import { inr, fmtDate, kycBadge, riskBadge } from "../../lib/format";
import AppLayout, { PageLoader, EmptyState, thCls, tdCls, rowCls } from "../../components/AppLayout";
import { Badge } from "../../components/ui/badge";

export default function WrmClients() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/wrm/overview").then((r) => setData(r.data)).catch((e) => setError(apiError(e)));
  }, []);

  if (error) return <AppLayout title="My Clients"><p className="text-red-400 text-sm">{error}</p></AppLayout>;
  if (!data) return <AppLayout title="My Clients"><PageLoader /></AppLayout>;

  return (
    <AppLayout title="My Clients" subtitle={`${data.clients.length} clients assigned to you`}>
      <div className="glass-card overflow-hidden fade-up">
        {data.clients.length === 0 ? <EmptyState message="No clients assigned yet." /> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="wrm-clients-full-table">
              <thead>
                <tr className="border-b border-white/[0.06]">
                  <th className={thCls}>Client</th>
                  <th className={thCls}>Contact</th>
                  <th className={`${thCls} text-right`}>Invested Value</th>
                  <th className={`${thCls} text-right`}>Current Portfolio Value</th>
                  <th className={thCls}>Risk</th>
                  <th className={thCls}>KYC</th>
                  <th className={thCls}>Last Activity</th>
                </tr>
              </thead>
              <tbody>
                {data.clients.map((c) => (
                  <tr key={c.id} onClick={() => navigate(`/wrm/clients/${c.id}`)} data-testid={`client-row-${c.id}`}
                    className={`${rowCls} cursor-pointer`}>
                    <td className={tdCls}>
                      <p className="font-medium text-white">{c.full_name}</p>
                      <p className="text-[11px] text-zinc-500 tnum">{c.investor_code}</p>
                    </td>
                    <td className={`${tdCls} text-xs text-zinc-500`} data-testid={`client-contact-${c.id}`}>
                      {c.email}<br />{c.mobile}
                      {c.contact_masked && <span className="text-[10px] text-zinc-600"> · masked</span>}
                    </td>
                    <td className={`${tdCls} text-right tnum text-zinc-300`} data-testid={`client-invested-${c.id}`}>{inr(c.invested ?? 0)}</td>
                    <td className={`${tdCls} text-right tnum text-zinc-100`}>{inr(c.aum)}</td>
                    <td className={tdCls}><Badge variant="outline" className={`text-[10px] ${riskBadge(c.risk_profile)}`}>{c.risk_profile}</Badge></td>
                    <td className={tdCls}><Badge variant="outline" className={`text-[10px] ${kycBadge(c.kyc_status)}`}>{c.kyc_status}</Badge></td>
                    <td className={`${tdCls} text-xs text-zinc-500 tnum`}>{fmtDate(c.last_activity)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AppLayout>
  );
}
